<template>
    <div class="date">
        <p :class="`date__day--${size}`">
            <b>{{ date.format('DD') }}</b>
        </p>

        <div class="date__">
            <p :class="`date__month-year--${size}`">
                {{ date.format('MMMM YYYY') }}
            </p>

            <template v-if="copy || $slots.copy">
                <p :class="`date__copy--${size}`">
                    <slot name="copy">
                        {{ copy }}
                    </slot>
                </p>
            </template>

            <template v-if="time || $slots.time">
                <p :class="`date__time--${size}`">
                    <slot name="time">
                        {{ time }}
                    </slot>
                </p>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            date: { type: Object, required: true },
            copy: { type: String, default: null },
            time: { type: String, default: null },
            size: { type: String, default: 'medium' },
        },
    }
</script>
